module.exports = __webpack_public_path__ + "static/media/email_icon.39d2c394.png";